import type {
  CreateDoctorAccountControlRequestInput,
  DoctorAccountControlApprovalDetail,
  DoctorAccountControlDoctorInbox,
  DoctorAccountControlDoctorSummary,
  DoctorAccountControlGrantSetting,
  DoctorAccountControlRequest,
  UpdateDoctorAccountControlGrantInput,
} from '@jema-manager/shared';
import { apiClient } from './api-client';

export const doctorAccountControlApi = {
  getDoctorSummary: async (doctorId: string): Promise<DoctorAccountControlDoctorSummary> => {
    const response = await apiClient.get<{ data: DoctorAccountControlDoctorSummary }>(
      `/doctor-control/doctors/${doctorId}/summary`
    );
    return response.data;
  },

  getMyDoctorInbox: async (): Promise<DoctorAccountControlDoctorInbox> => {
    const response = await apiClient.get<{ data: DoctorAccountControlDoctorInbox }>(
      '/doctor-control/doctor/me',
      undefined,
      {
        timeoutProfile: 'dashboard',
      }
    );
    return response.data;
  },

  getMyStandingGrant: async (): Promise<DoctorAccountControlGrantSetting> => {
    const response = await apiClient.get<{ data: DoctorAccountControlGrantSetting }>(
      '/doctor-control/doctor/me/standing-grant',
      undefined,
      {
        timeoutProfile: 'dashboard',
      }
    );
    return response.data;
  },

  updateMyStandingGrant: async (
    payload: UpdateDoctorAccountControlGrantInput
  ): Promise<DoctorAccountControlGrantSetting> => {
    const response = await apiClient.patch<{ data: DoctorAccountControlGrantSetting }>(
      '/doctor-control/doctor/me/standing-grant',
      payload
    );
    return response.data;
  },

  getApprovalDetail: async (token: string): Promise<DoctorAccountControlApprovalDetail> => {
    const response = await apiClient.get<{ data: DoctorAccountControlApprovalDetail }>(
      `/doctor-control/approval/${token}`,
      undefined,
      {
        timeoutProfile: 'dashboard',
      }
    );
    return response.data;
  },

  create: async (
    payload: CreateDoctorAccountControlRequestInput
  ): Promise<DoctorAccountControlRequest> => {
    const response = await apiClient.post<{ data: DoctorAccountControlRequest }>(
      '/doctor-control/requests',
      payload
    );
    return response.data;
  },

  approve: async (requestId: string): Promise<DoctorAccountControlRequest> => {
    const response = await apiClient.post<{ data: DoctorAccountControlRequest }>(
      `/doctor-control/requests/${requestId}/approve`
    );
    return response.data;
  },

  deny: async (requestId: string): Promise<DoctorAccountControlRequest> => {
    const response = await apiClient.post<{ data: DoctorAccountControlRequest }>(
      `/doctor-control/requests/${requestId}/deny`
    );
    return response.data;
  },

  approveByToken: async (token: string): Promise<DoctorAccountControlRequest> => {
    const response = await apiClient.post<{ data: DoctorAccountControlRequest }>(
      `/doctor-control/approval/${token}/approve`
    );
    return response.data;
  },

  denyByToken: async (token: string): Promise<DoctorAccountControlRequest> => {
    const response = await apiClient.post<{ data: DoctorAccountControlRequest }>(
      `/doctor-control/approval/${token}/deny`
    );
    return response.data;
  },

  start: async (requestId: string): Promise<DoctorAccountControlRequest> => {
    const response = await apiClient.post<{ data: DoctorAccountControlRequest }>(
      `/doctor-control/requests/${requestId}/start`
    );
    return response.data;
  },

  end: async (requestId: string): Promise<DoctorAccountControlRequest> => {
    const response = await apiClient.post<{ data: DoctorAccountControlRequest }>(
      `/doctor-control/requests/${requestId}/end`
    );
    return response.data;
  },

  revoke: async (requestId: string): Promise<DoctorAccountControlRequest> => {
    const response = await apiClient.post<{ data: DoctorAccountControlRequest }>(
      `/doctor-control/requests/${requestId}/revoke`
    );
    return response.data;
  },
};
